<template>
  <MDBRow>
    <MDBCol class="mt-5">
      <nav>
        <ul class="pagination justify-content-center">
          <li class="page-item" v-for="(link, key) in meta.links" v-bind:key="key">
            <button v-if="key === 0" :class="`page-link font-16 
                ${link.url === null ? 'disabled' : ''} 
                ${link.active ? 'active' : ''}`" @click="changeProductPage(key)" type="button" >
                  <MDBIcon class="me-1 font-10" icon="chevron-left" size="1x" />
                </button>
            <button v-else-if="key === (meta.links.length - 1)" :class="`page-link font-16 
                ${link.url === null ? 'disabled' : ''} 
                ${link.active ? 'active' : ''}`" @click="changeProductPage(key)" type="button">
                  <MDBIcon class="me-1 font-10" icon="chevron-right" size="1x" />
                </button>
            <button v-else :class="`page-link font-16 
                ${link.url === null ? 'disabled' : ''} 
                ${link.active ? 'active' : ''}`" @click="changeProductPage(key)" type="button"
              v-html="link.label"></button>
          </li>
        </ul>
      </nav>
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import { MDBRow, MDBCol, MDBIcon } from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import { defineEmits } from "vue";

const store = useStore();
const meta = store.getters.getProductsMeta;
const emit = defineEmits(["pageNumberChanged"]);

function changeProductPage(key) {
  const url = meta.links[key].url;

  if (url === null) {
    return;
  }

  const pageNumber = url.match(/\d*$/g)[0];
  emit("pageNumberChanged", pageNumber);
}
</script>

<style scoped lang="scss">
@import "../../styles/_variables.scss";

.page-link {
  background: white;
  margin: 0 5px;
  border-radius: 0px;
}

.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.active {
  background: $dangerRed;
  color: white;
}
</style>
